<template>
  <b-modal
    id="change-default-card"
    ref="change-default-card"
    body-class="p-10"
    centered
    title="Change Default Card"
    @show="setModalData"
    @hidden="resetModal"
    @ok="changeDefaultCard"
  >
    <b-overlay
      id="overlay-new-card"
      :show="isModalLoading"
      variant="white"
      opacity="1"
      rounded="sm"
    >
      <b-form-group label="Application selection">
        <v-select
          v-model="selectedApplication"
          :options="applicationsList"
          label="user_full_name"
          class="customSelect"
          placeholder="Please Select Application"
          :clearable="false"
          @input="selectApp"
        >
          <template #selected-option="{ program_name, user_full_name }">
            <span>{{ user_full_name }}</span
            >&nbsp;-&nbsp;<span>{{ program_name }}</span>
          </template>

          <template #option="{ program_name, user_full_name }">
            <span>{{ user_full_name }}</span> - <span>{{ program_name }}</span>
          </template>
        </v-select>
      </b-form-group>

      <b-form-group label="Credit Card">
        <CreditCardRadioBlock
          v-for="card in cardsList"
          :key="card.id"
          :card="card"
          :show-delete-card="false"
        />
        <b-button variant="primary" class="w-100 mt-2" v-b-modal.add-new-card>
          Add New Credit Card +
        </b-button>
      </b-form-group>
    </b-overlay>
    <template #modal-footer="{ cancel, ok }">
      <div class="w-100 d-flex justify-content-between">
        <b-button
          class="border border-primary"
          variant="outline-primary"
          @click="cancel()"
        >
          Cancel
        </b-button>
        <b-button
          variant="primary"
          :disabled="submitButtonIsLoading || isOkButtonDisabled"
          @click="ok()"
        >
          Save
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import store from '@/store'

import { BModal, BButton, BOverlay, BFormGroup } from "bootstrap-vue"

import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import CreditCardRadioBlock from '@/components/site/CreditCardRadioBlock.vue'
import { setStatusModalData } from '@core/mixins/setStatusModalData'

export default {
  name: "ChangeDefaultCard",
  components: {
    BModal,
    BButton,
    BOverlay,
    BFormGroup,
    vSelect,

    CreditCardRadioBlock,
  },
  mixins: [setStatusModalData],
  data() {
    return {
      submitButtonIsLoading: false,
    }
  },
  computed: {
    ...mapGetters({
      applicationsList: 'paymentPortal/getApplications',
      cardsList: 'cards/getCardsList',
    }),
    selectedApplication: {
      get: function () {
        return store.getters['paymentPortal/getSelectedApplication']
      },
      set: function (val) {
        store.commit('paymentPortal/SET_SLECTED_APPLICATION', val)
      },
    },
    selectedCard: {
      get: function () {
        return store.getters['cards/getSelectedCreditCard']
      },
      set: function (val) {
        store.commit('cards/SET_SELECTED_CREDIT_CARD', val)
      }
    },
    isModalLoading: {
      get: function () {
        return store.getters['paymentPortal/getIsModalLoaidng']
      },
      set: function (val) {
        store.commit('paymentPortal/SET_MODAL_LOADING_STATE', val)
      },
    },
    isOkButtonDisabled() {
      return !this.selectedApplication || !this.selectedCard
    },
  },
  methods: {
    async setModalData() {
      this.isModalLoading = true
      await store.dispatch('cards/loadCards')
      await store.dispatch('paymentPortal/fetchApplications', { without_archived: false })

      this.isModalLoading = false
    },
    resetModal() {
      this.selectedApplication = null
      this.selectedCard = null
    },
    selectApp(application) {
      this.selectedCard = application.card_id
    },
    async changeDefaultCard(bvModalEvt) {
      bvModalEvt.preventDefault()

      this.submitButtonIsLoading = true;
      this.isModalLoading = true

      const queryParams = {
        application_id: this.selectedApplication?.id,
        card_id: this.selectedCard,
      }

      try {
        await store.dispatch('cards/changeDefaultCard', queryParams)

        this.showStatusModal({
          title: 'Change Default Card',
          status: 'Success',
          header: 'Default Card for this application was changed',
          message: '',
        })

        // Refresh data after success
        store.dispatch('paymentPortal/refreshData')
      } catch (e) {
        this.showStatusModal({
          title: 'Change Default Card',
          status: 'Failed',
          header: 'Error changing default Card',
          message: '',
        })
      } finally {
        this.submitButtonIsLoading = false
        this.isModalLoading = false
      }
    },
    showStatusModal(data) {
      this.setStatusModalData(data)
      this.$bvModal.hide('change-default-card')
      this.$bvModal.show('status-modal')
    },
  },
};
</script>

<style>
</style>